import { ActionbarService } from './../services/actionbar.service';
import { ScopeService } from './../services/scope.service';

import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription, combineLatest } from 'rxjs';
import { MenuItem, SelectItem } from 'primeng/api';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { ActionbarDropdown } from '../services/interfaces';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-actionbar',
  templateUrl: './app.actionbar.component.html'
})
export class AppActionBarComponent implements OnInit, OnDestroy {

  breadcrumbSub: Subscription;

  items: MenuItem[];



  filterDropdownsSub: Subscription;
  dropdowns: ActionbarDropdown[];
  listStatusDD: SelectItem[];

  newButtonSub: Subscription;
  newButtons: string[] = [];

  exportButtonSub: Subscription;
  showExportButton = false;

  showCardsButtonSub: Subscription;
  showCardsButton = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private actionbarService: ActionbarService,
  ) {
  }

  ngOnInit() {

    this.newButtonSub = this.actionbarService.newButtonBS
      .subscribe(labels => {
        this.newButtons = labels;
      });

    this.breadcrumbSub = this.breadcrumbService.itemsHandler
      .subscribe(items => {
      // console.log('items', items);
        this.items = items;
      });

      this.exportButtonSub = this.actionbarService.exportButton
      .subscribe(val => {
        this.showExportButton = val;
      });

      this.showCardsButtonSub = this.actionbarService.showCardsButtonBS
      .subscribe(val => {
        this.showCardsButton = val;
      });


    this.filterDropdownsSub = this.actionbarService.filterDropdownBS
      .subscribe((dropdowns) => {
        this.dropdowns = dropdowns;
        dropdowns.forEach(el => {
          this.actionbarService.filterDropdownChanged.next({name: el.name, value: el.initvalue});
        });
      });
  }

  onChangeDropdown(event, name) {
    this.actionbarService.filterDropdownChanged.next({name, value: event.value});
  }

  onNew(label: string) {
    this.actionbarService.newButtonClicked.next(label);
  }

  onShowAllCards() {
    this.actionbarService.showCardsButtonClicked.next('showAllCards');
  }

  onDownload() {
    this.actionbarService.exportNow.next('now');
  }

  ngOnDestroy() {
    if (this.breadcrumbSub) {
      this.breadcrumbSub.unsubscribe();
    }
    if (this.showCardsButtonSub) {
      this.showCardsButtonSub.unsubscribe();
    }
    if (this.filterDropdownsSub) {
      this.filterDropdownsSub.unsubscribe();
    }
    if (this.newButtonSub) {
      this.newButtonSub.unsubscribe();
    }
    if (this.exportButtonSub) {
      this.exportButtonSub.unsubscribe();
    }
  }
}
